import { initializeApp } from "firebase/app";
import { getAuth, browserLocalPersistence, setPersistence, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { setAuthUser, getAuthUser } from "components/Auth/authStore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "YOUR_PROJECT.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "YOUR_PROJECT_ID",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "YOUR_PROJECT.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "YOUR_SENDER_ID",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "YOUR_APP_ID",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const auth = getAuth(app);

setPersistence(auth, browserLocalPersistence).catch(() => {});

export const authReady = new Promise((resolve) => {
  const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
    if (firebaseUser) {
      const local = getAuthUser();
      if (!local || local.id !== firebaseUser.uid) {
        setAuthUser({
          id: firebaseUser.uid,
          provider: firebaseUser.providerData?.[0]?.providerId || firebaseUser.providerId || "unknown",
          phone: firebaseUser.phoneNumber || null,
          email: firebaseUser.email || null,
          displayName: firebaseUser.displayName || null,
          role: local?.role || "editor",
          createdAt: local?.createdAt || new Date().toISOString(),
        });
      }
    }
    resolve(firebaseUser);
    unsubscribe();
  });
});

onAuthStateChanged(auth, (firebaseUser) => {
  if (firebaseUser) {
    const local = getAuthUser();
    if (!local || local.id !== firebaseUser.uid) {
      setAuthUser({
        id: firebaseUser.uid,
        provider: firebaseUser.providerData?.[0]?.providerId || firebaseUser.providerId || "unknown",
        phone: firebaseUser.phoneNumber || null,
        email: firebaseUser.email || null,
        displayName: firebaseUser.displayName || null,
        role: local?.role || "editor",
        createdAt: local?.createdAt || new Date().toISOString(),
      });
    }
  }
});

export const storage = getStorage(app);

export default app;
